export default __webpack_public_path__ + "static/media/sentiment_neutral.50824c65.svg";